import { findFeedbackById } from "../../util/foodReview/findFeedbackById";
import FeedbackDisplayArea from "../FeedbackDisplayArea";
import classes from "./FoodFeedbackDisplay.module.css";
export default function FoodFeedbackDisplay({ data }) {
  // console.log(data);
  //input data format would be feedback_id.
  // [{foodName:"df",feedback_id:"432f"}]
  // we need function that can extract relevant feedbacks from local storage
  // as per feedback_id in this input data.
  const feedbackData = findFeedbackById(data);
  console.log(feedbackData);
  if (feedbackData == null) return;
  return (
    <>
      <div className={classes.container}>
        <FeedbackDisplayArea data={feedbackData} />
      </div>
    </>
  );
}
